import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import errorCode from './errorCode'
import router from '.././router'
import store from '../store'
// import { config } from 'vue/types/umd'
// 设置请求传递数据的格式(看服务器要求什么格式)
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
//console.log(process.env)
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    // baseURL: process.env.API_ROOT,
    baseURL: '',
    
    // 超时
    timeout: 10000
})
let requestUrl = ''
// 请求拦截器
service.interceptors.request.use(config => {
    const videoToken = window.localStorage.getItem("videoToken")
    const paasToken = window.localStorage.getItem("paasToken")
    const oauthToken = window.localStorage.getItem("oauthToken")
    if(videoToken) {
        config.headers["videoToken"] = videoToken
    }
    if(paasToken) {
        config.headers["token"] = paasToken
    }
    if(oauthToken) {
        config.headers["Authorization"] = 'bearer ' + oauthToken
    }
    requestUrl = config.url;
    return config
}, error => {
    return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(res => {
		if(res.data.data && res.data.data.code == 401) {
			window.localStorage.removeItem("oauthToken");
			window.localStorage.removeItem("videoToken");
			window.localStorage.removeItem('token');
			window.localStorage.removeItem('platformNameList');
			window.localStorage.removeItem('realName');
			window.localStorage.removeItem("visitorPhone");
			window.localStorage.removeItem("userDetailInfo");
            window.localStorage.removeItem("userInfo");
			window.sessionStorage.removeItem("userInfo");
			router.push("/controlLogin");        
            store.commit("update", ["realName", ""]);
            store.commit("update", ["platformNameList", []]);
            store.commit("update", ["visitorPhone", ""]);
		}
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    if(requestUrl.indexOf('richTextFile') > -1) {
			return res.data.data
    }
    if (code == 401) {
        Message({
            message: msg,
            type: 'error',
            duration: 2 * 1000,
            onClose: () => {
                router.push("/controlLogin");
            }
        })
    }
    if (code == 400) {
        Message({
            message: msg,
            type: 'error',
            duration: 2 * 1000,
            onClose: () => {
                router.push("/login");
            }
        })
    }
    if (code == 500) {
        Message({
            message: msg,
            type: 'error',
            duration: 2 * 1000,
        })
    }else if(code == 403 && requestUrl.indexOf('video/getPlayInfo')>-1){
			window.localStorage.removeItem("oauthToken");
			window.localStorage.removeItem("videoToken");
			window.localStorage.removeItem('token');
			window.localStorage.removeItem('platformNameList');
			window.localStorage.removeItem('realName');
			window.localStorage.removeItem("visitorPhone");
			window.localStorage.removeItem("userDetailInfo");
			window.localStorage.removeItem("userInfo");
			window.sessionStorage.removeItem("userInfo");
            store.commit("update", ["realName", ""]);
            store.commit("update", ["platformNameList", []]);
            store.commit("update", ["visitorPhone", ""]);

    }else if(code==403){
			window.localStorage.removeItem("oauthToken");
			window.localStorage.removeItem("videoToken");
			window.localStorage.removeItem('token');
			window.localStorage.removeItem('platformNameList');
			window.localStorage.removeItem('realName');
			window.localStorage.removeItem("visitorPhone");
			window.localStorage.removeItem("userDetailInfo");
			window.localStorage.removeItem("userInfo");
			window.sessionStorage.removeItem("userInfo");
            store.commit("update", ["realName", ""]);
            store.commit("update", ["platformNameList", []]);
            store.commit("update", ["visitorPhone", ""]);
      router.push('/controlLogin')
    }
    return res.data;
}, error => {
    if(error.response.status == 401) {
        // Message({
        //     message: '您还没登陆或您已登录但没有后台管理系统的权限，请登录或联系管理员配置权限！',
        //     type: 'error',
        //     duration: 5 * 1000
        // })
        store.commit("update", ["realName", ""]);
        store.commit("update", ["platformNameList", []]);
        store.commit("update", ["visitorPhone", ""]);
        router.push('/controlLogin')
    } else {
        Message({
            message: error.response.data.msg,
            type: 'error',
            duration: 5 * 1000
        })
    }
    return Promise.reject(error);
});

export default service


// WEBPACK FOOTER //
// ./src/api/request.js